import { RobaFormComponent } from './../../../../../roba/src/lib/roba-form/roba-form.component';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { GetPredmeteStavkiZaEotpremnicuQuery, IPredmetStavkeDto, IPredmetStavkeZaEOtpremnicuDto, SubscriptionPackage, PredmetStavkiClient, ResultOfRobaCommandResponse } from '@kodit/core/data-api';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { Subscription } from 'rxjs';
import { EOtpremnicaForm, EotpremnicaFormService } from '../../otpremnice/eotpremnica-form.service';
import { AuthService } from '@kodit/core/services';
import { ActivatedRoute } from '@angular/router';
import { KreiranjePrijemniceFormService } from '../../prijemnice/kreiranje-prijemnice-form.service';

export interface PredmetStavkeResult {
  predmetStavke: IPredmetStavkeDto;
  amount: number;
  //osnovnaCena: number;
  // price: number;
}

@Component({
  selector: 'kodit-rezultat-pretrage-stavke',
  templateUrl: './rezultat-pretrage-stavke.component.html',
  styleUrls: ['./rezultat-pretrage-stavke.component.scss']
})
export class RezultatPretrageStavkeComponent implements OnInit, OnChanges, OnDestroy {

  /** Subs */
  private _subs: Subscription = new Subscription();
  private _searchPredmetStavkeSub: Subscription = new Subscription();
  private _dialogCloseSub: Subscription = new Subscription();

  /** Configurations */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(
    DialogSize.MEDIUM
  );

    /** Props */
  predmetiStavkiZaOtpremnicuResult: IPredmetStavkeZaEOtpremnicuDto[] = [];
  predmetiStavkiResult: IPredmetStavkeDto[] = [];
  shouldDisplayLoader: boolean;
  defaultKolicina: number = 1;
  existingStavkeRacuna: number[] = [];
  hasRobno: boolean = false;
  lastSearchValue: string;

   /** I/O */
  @Input() searchValue: string = '';
  @Input() iznosDefaultValue: number;
  @Input() jmDefaultValue: string;
  @Output() onPredmetStavkeAdd = new EventEmitter<PredmetStavkeResult>();

  constructor(
    private _client: PredmetStavkiClient,
    private _dialogService: DynamicDialogService,
    private _formService: EotpremnicaFormService,
    private _authService: AuthService,
    private _routing: ActivatedRoute,
    private _fs: EotpremnicaFormService,
    private _prijemnicaService: KreiranjePrijemniceFormService
  ) { }

  ngOnInit(): void {
    this._subs.add(
      this._formService.getAddedPredmetiStavki.subscribe((res) => {
        if (res?.length > 0) {
          this.existingStavkeRacuna = [...res];
        } else {
          this.existingStavkeRacuna = [];
        }
      })
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.searchValue?.currentValue != changes.searchValue?.previousValue
    ) {
      this.searchPredmetStavke(this.searchValue);
    }
  }

  searchPredmetStavke(searchValue: string) {

    this.lastSearchValue = searchValue;
    if (!searchValue || searchValue.length == 0) {
      return;
    }
    this.shouldDisplayLoader = true;
    this._searchPredmetStavkeSub = this._client
      .getPredmeteStavkeZaEOtpremnicu(
        new GetPredmeteStavkiZaEotpremnicuQuery({
          sifraIliNaziv: searchValue,
          includeMaterijal: false,
          magacinId: this._fs.getOtpremnicaFormObject?.controls.adresaOtpremeDto?.value.magacinId
        })
      )
      .subscribe(
        (result) => {
          this.predmetiStavkiZaOtpremnicuResult = result.predmetiStavkiZaOtpremnicu;
          this.predmetiStavkiResult = result.predmetiStavki;
        },
        (error) => {},
        () => {
          this.shouldDisplayLoader = false;
        }
      );
  }

  dodajPredmetStavke(id: number) {
    if (id === -1) {
      this.onPredmetStavkeAdd.emit(null);
    } else {
      const ps = this.predmetiStavkiResult.find((x) => x.id === id);
      this.onPredmetStavkeAdd.emit({
        predmetStavke: ps,
        amount: this.defaultKolicina,
      });
      this._formService.setAddedPredmetiStavki = [
        ...this.existingStavkeRacuna,
        id,
      ];
    }
  }

  openRobaDialog(config: DynamicDialogConfig) {
    config.data = {
      naziv: this.searchValue,
      iznos: this.iznosDefaultValue,
      jm: this.jmDefaultValue,
    };
    config.setDialogSize = DialogSize.MEDIUM;
    config.header = 'Unos podataka robe';
    const ref = this._dialogService.open(RobaFormComponent, config);
    this._dialogCloseSub = ref.onClose.subscribe(
      (result: ResultOfRobaCommandResponse) => {
        this.onPredmetStavkeAdd.emit({
          predmetStavke: result?.data?.robaDto?.predmetStavkeDto,
          amount: this.defaultKolicina,
        });
      }
    );
  }

  inputFocused(event: any) {
    event.target.select();
  }

  ngOnDestroy() {
    this._searchPredmetStavkeSub.unsubscribe();
    this._dialogCloseSub.unsubscribe();
    this._subs.unsubscribe();
  }

}
